module.exports = {
    "collapse": `Sbalit`,
    "expand": `Rozt\xe1hnout`
};


//# sourceMappingURL=cs-CZ.main.js.map
